import PropTypes from 'prop-types'
import { Component } from 'react'

import Day from './Day'
import WeekNumber from './WeekNumber'

class Week extends Component {
  constructor (props) {
    super(props)
    this.handleDayClick = this.handleDayClick.bind(this)
    this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this)
  }

  handleDayClick = (day, event) => {
    const { onDayClick } = this.props
    if (onDayClick) {
      onDayClick(day, event)
    }
  }

  handleDayMouseEnter = day => {
    const { onDayMouseEnter } = this.props
    if (onDayMouseEnter) {
      onDayMouseEnter(day)
    }
  }

  renderDays = () => {
    const startOfWeek = this.props.day.clone().startOf('week')
    const days = []
    if (this.props.showWeekNumber) {
      days.push(
        <WeekNumber
          key='W'
          weekNumber={parseInt(startOfWeek.format('w'), 10)}
        />
      )
    }
    return days.concat(
      [ 0, 1, 2, 3, 4, 5, 6 ].map(offset => {
        const day = startOfWeek.clone().add(offset, 'days')
        return (
          <Day
            key={offset}
            day={day}
            month={this.props.month}
            onClick={event => this.handleDayClick(day, event)}
            onMouseEnter={() => this.handleDayMouseEnter(day)}
            minDate={this.props.minDate}
            maxDate={this.props.maxDate}
            excludeDates={this.props.excludeDates}
            includeDates={this.props.includeDates}
            inline={this.props.inline}
            highlightDates={this.props.highlightDates}
            selectingDate={this.props.selectingDate}
            filterDate={this.props.filterDate}
            preSelection={this.props.preSelection}
            selected={this.props.selected}
            selectsStart={this.props.selectsStart}
            selectsEnd={this.props.selectsEnd}
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            utcOffset={this.props.utcOffset}
          />
        )
      })
    )
  }

  render () {
    return <div className='react-datepicker__week'>{this.renderDays()}</div>
  }
}

Week.displayName = 'Week'

Week.propTypes = {
  day: PropTypes.instanceOf(Object).isRequired,
  endDate: PropTypes.instanceOf(Object),
  excludeDates: PropTypes.instanceOf(Array),
  filterDate: PropTypes.func,
  highlightDates: PropTypes.instanceOf(Array),
  includeDates: PropTypes.instanceOf(Array),
  inline: PropTypes.bool,
  maxDate: PropTypes.instanceOf(Object),
  minDate: PropTypes.instanceOf(Object),
  month: PropTypes.number,
  onDayClick: PropTypes.func,
  onDayMouseEnter: PropTypes.func,
  preSelection: PropTypes.instanceOf(Object),
  selected: PropTypes.instanceOf(Object),
  selectingDate: PropTypes.instanceOf(Object),
  selectsEnd: PropTypes.bool,
  selectsStart: PropTypes.bool,
  showWeekNumber: PropTypes.bool,
  startDate: PropTypes.instanceOf(Object),
  utcOffset: PropTypes.number
}

export default Week
